import React from "react";
import { Link } from "react-router-dom";

import NotFound from "../../assets/NotFound.png";

const PageNotFound = () => {
  return (
    // Outer container with background styling
    <div className="bg-blue-10 page-not-found-outer-container center-alignment">
      {/* Inner container with white background, centered alignment, and padding */}
      <div className="bg-white center-alignment flex-column rounded p-5">
        {/* Image for the 'Not Found' page */}
        <img src={NotFound} alt="Email Sent" className="img-fluid " />

        {/* Heading for the 'Not Found' page */}
        <h5 className="text-primary-sapphire fw-600 fs-22 mt-4">
          Page Not Found
        </h5>

        {/* Button for back to the home page */}
        <footer className="fs-20 fw-500">
          <Link
            to="/"
            className="cursor-pointer text-gray-900 text-decoration-none"
          >
            Home
          </Link>
        </footer>
      </div>
    </div>
  );
};

export default PageNotFound;
